import { render, staticRenderFns } from "./GenresList.vue?vue&type=template&id=521458b6"
import script from "./GenresList.vue?vue&type=script&lang=js"
export * from "./GenresList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports